import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EnderecoInfosAdicionaisPage } from './endereco-infos-adicionais.page';

const routes: Routes = [{ path: '', component: EnderecoInfosAdicionaisPage }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EnderecoInfosAdicionaisRoutingModule { }
